import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ } from "@/constants/testIds";
import { useLang } from "@/i18n/LanguageContext";
import { OrchidFlourish, RoseFlourish } from "@/components/wedding/Flourish";

export const Faq = () => {
  const { t } = useLang();
  const heading = t("faq.heading");
  const items = t("faq.items") || [];

  return (
    <section id="faq" data-testid={FAQ.section} className="relative py-24 sm:py-32 overflow-hidden">
      <OrchidFlourish
        className="absolute -top-6 -left-6 w-[100px] sm:w-[140px] md:w-[180px]"
        opacity={0.8}
      />
      <RoseFlourish
        className="absolute -bottom-8 -right-6 w-[100px] sm:w-[140px] md:w-[180px] rotate-6"
        opacity={0.8}
      />
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="md:sticky md:top-28">
            <h2 className="mt-4 font-display text-5xl sm:text-6xl tracking-tighter font-light">
              {heading[0]}<em className="italic">{heading[1]}</em>{heading[2]}
            </h2>
            <p className="mt-6 font-serif italic text-lg text-black/65 max-w-sm">{t("faq.sub")}</p>
          </div>
        </div>

        <div className="md:col-span-8">
          <Accordion type="single" collapsible className="border-t border-black/15">
            {items.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-b border-black/15"
              >
                <AccordionTrigger
                  data-testid={FAQ.trigger(i)}
                  className="font-title text-2xl sm:text-3xl tracking-tight py-6 hover:no-underline text-left"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="font-sans text-base leading-relaxed text-black/70 pb-8 pr-8 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
